<div class="stitch-modal-container">
  <!-- Botón Cerrar Modal -->
  <button type="button" class="btn-stitch-close" aria-label="Cerrar" (click)="closeModal()">
    <i class="fas fa-times"></i>
  </button>

  <div class="stitch-modal-body row g-4">
    <!-- Columna Izquierda: Galería de Imágenes -->
    <div class="col-lg-6 col-md-6 modal-media-column">
      <div class="main-image-card">
        <span class="badge-modal-discount" *ngIf="data.product.discountPercentage || data.product.hasDiscount">
          -{{ data.product.discountPercentage || 20 }}% DCTO
        </span>
        <img [src]="resolveImg(selectedImage)" [alt]="data.product.name" class="img-fluid main-modal-img"
          (error)="onImageError($event)" />
      </div>

      <!-- Tira de Miniaturas -->
      <div *ngIf="productImages.length > 1" class="thumbnail-strip d-flex gap-2 justify-content-center mt-3">
        <div *ngFor="let img of productImages" class="thumb-item" [class.active]="selectedImage === img"
          (click)="selectedImage = img">
          <img [src]="resolveImg(img)" [alt]="data.product.name" (error)="onImageError($event)" />
        </div>
      </div>

      <!-- Insignias de Confianza -->
      <div class="trust-features-grid mt-4">
        <div class="trust-item">
          <i class="fas fa-truck-fast text-primary"></i>
          <div>
            <strong>Envío Expres</strong>
            <span>Coordinadora & Servientrega</span>
          </div>
        </div>
        <div class="trust-item">
          <i class="fas fa-shield-alt text-success"></i>
          <div>
            <strong>Garantía Oficial</strong>
            <span>30 días sin costo</span>
          </div>
        </div>
        <div class="trust-item">
          <i class="fas fa-undo text-purple"></i>
          <div>
            <strong>Devolución Gratis</strong>
            <span>Retorno fácil y rápido</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Columna Derecha: Información & Opciones de Compra -->
    <div class="col-lg-6 col-md-6 modal-details-column">
      <div class="d-flex align-items-center gap-2 mb-2">
        <span class="modal-category-badge">{{ data.product.category || 'Catálogo Exclusivo' }}</span>
        <span *ngIf="data.product.brand" class="modal-brand-badge">{{ data.product.brand }}</span>
      </div>

      <h2 class="modal-product-title">{{ data.product.name }}</h2>

      <!-- Precios -->
      <div class="modal-price-box mb-4">
        <span class="modal-current-price">${{ data.product.price | number }} COP</span>
        <span *ngIf="data.product.originalPrice" class="modal-original-price">${{ data.product.originalPrice | number
          }}</span>
        <span class="modal-savings-tag" *ngIf="data.product.originalPrice">
          Ahorras ${{ (data.product.originalPrice - data.product.price) | number }}
        </span>
      </div>

      <!-- Selector de Tallas (si aplica) -->
      <div class="modal-option-group mb-3" *ngIf="data.product.sizes && data.product.sizes.length > 0">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="modal-option-label">Selecciona Talla / Dimensión:</label>
          <button *ngIf="sizeTable.length > 0" class="btn-size-guide" (click)="showSizeGuide = true">
            <i class="fas fa-ruler-combined me-1"></i>Guía de Tallas
          </button>
        </div>
        <div class="modal-size-chips">
          <button *ngFor="let size of data.product.sizes" class="modal-chip-btn"
            [class.selected]="selectedSize === size.valor" (click)="selectSize(size)">
            {{ size.valor }}
          </button>
        </div>
      </div>

      <!-- Selector de Colores (si aplica) -->
      <div class="modal-option-group mb-3" *ngIf="availableColors.length > 0">
        <label class="modal-option-label">Color Seleccionado: <strong class="text-capitalize">{{ selectedColor
            }}</strong></label>
        <div class="modal-color-swatches">
          <button *ngFor="let color of availableColors" class="modal-swatch-btn"
            [class.selected]="selectedColor === color" (click)="selectedColor = color" [ngStyle]="getColorStyle(color)"
            [title]="color">
            <i *ngIf="selectedColor === color" class="fas fa-check"
              [ngClass]="color === 'blanco' ? 'text-dark' : 'text-white'"></i>
          </button>
        </div>
      </div>

      <!-- Dispositivos & Stock -->
      <div class="modal-stock-info mb-3">
        <span class="stock-badge" [class.in-stock]="getAvailableStock() > 0"
          [class.out-stock]="getAvailableStock() <= 0">
          <i class="fas" [ngClass]="getAvailableStock() > 0 ? 'fa-check-circle' : 'fa-times-circle'"></i>
          {{ getAvailableStock() > 0 ? ('Disponible') : 'Agotado Temporalmente' }}
        </span>
      </div>

      <!-- Control de Cantidad -->
      <div class="modal-quantity-wrapper mb-4">
        <label class="modal-option-label d-block mb-2">Cantidad:</label>
        <div class="d-flex align-items-center gap-3">
          <div class="stitch-quantity-control">
            <button class="qty-btn" (click)="deincreaseQuantity()" [disabled]="quantity <= 1">
              <i class="fas fa-minus"></i>
            </button>
            <input type="number" class="qty-input" [(ngModel)]="quantity" (input)="validateQuantity()" min="1"
              [max]="getAvailableStock()" />
            <button class="qty-btn" (click)="increaseQuantity()" [disabled]="quantity >= getAvailableStock()">
              <i class="fas fa-plus"></i>
            </button>
          </div>

          <div class="total-display">
            <span class="total-label">Subtotal:</span>
            <span class="total-value">${{ total | number }} COP</span>
          </div>
        </div>
      </div>

      <!-- Botones de Acción -->
      <div class="modal-action-buttons d-flex gap-3 mb-4">
        <button class="btn-stitch-primary flex-grow-1" (click)="addToCart()" [disabled]="getAvailableStock() <= 0">
          <i class="fas fa-shopping-cart me-2"></i>Añadir al Carrito
        </button>
        <button class="btn-stitch-accent flex-grow-1" (click)="buyNow()" [disabled]="getAvailableStock() <= 0">
          <i class="fas fa-bolt me-2"></i>Comprar Ahora
        </button>
      </div>

      <!-- Tabs de Información Adicional -->
      <div class="modal-info-tabs">
        <div class="tabs-header d-flex border-bottom mb-3">
          <button class="tab-btn" [class.active]="activeTab === 'desc'"
            (click)="activeTab = 'desc'">Descripción</button>
          <button class="tab-btn" [class.active]="activeTab === 'specs'"
            (click)="activeTab = 'specs'">Especificaciones</button>
          <button class="tab-btn" [class.active]="activeTab === 'shipping'"
            (click)="activeTab = 'shipping'">Políticas</button>
        </div>

        <div class="tab-content">
          <div *ngIf="activeTab === 'desc'" class="tab-pane">
            <p>{{ data.product.description }}</p>
          </div>
          <div *ngIf="activeTab === 'specs'" class="tab-pane">
            <ul class="specs-list">
              <li><strong>Categoría:</strong> {{ data.product.category }}</li>
              <li><strong>Marca:</strong> {{ data.product.brand || 'Original Andes' }}</li>
              <li><strong>Garantía:</strong> 30 Días Garantía Directa</li>
              <li><strong>Origen:</strong> Importado / Fabricación Nacional Certificada</li>
            </ul>
          </div>
          <div *ngIf="activeTab === 'shipping'" class="tab-pane">
            <p class="small text-muted">
              Todos los envíos cuentan con número de guía rastreable en tiempo real. Garantizamos reemplazo 100%
              gratuito en caso de cualquier inconveniente en el transporte.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal Flotante de Guía de Tallas -->
<div class="size-guide-backdrop" *ngIf="showSizeGuide">
  <div class="size-guide-modal-content">
    <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
      <h5 class="m-0 font-weight-bold"><i class="fas fa-ruler me-2 text-primary"></i>Guía Oficial de Tallas</h5>
      <button class="btn-close-guide" (click)="showSizeGuide = false">&times;</button>
    </div>
    <table class="table table-striped table-hover text-center align-middle">
      <thead>
        <tr>
          <th>Talla / EU</th>
          <th>Medida (CM)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of sizeTable">
          <td><strong>{{ row[0] }}</strong></td>
          <td>{{ row[1] || row[0] }}</td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-secondary btn-sm w-100 mt-2" (click)="showSizeGuide = false">Cerrar Guía</button>
  </div>
</div>